

import {listDataQa} from '@/zsm-api-new/qa.js'
const state = {

}

const mutations = {

}

const actions = {

  // 获取问题列表
  listDataQa({ commit }, info) {
    return new Promise((resolve, reject) => {
      listDataQa(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取单个问题
  getQa({ commit }, id) {
    return new Promise((resolve, reject) => {
      getQa(id).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 问题赞或踩
  scoreQa({ commit }, info) {
    return new Promise((resolve, reject) => {
      scoreQa(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
